import { getAccessToken } from './storage'
import { notification } from '../AntdGlobal';

export type ApiResult<T> = {
  ok: true
  data: T
} | {
  ok: false
  error: string
}

function getBaseUrl(): string {
  return 'https://admapi.undroid.pro'
}

async function requestJson<T>(path: string, init?: RequestInit): Promise<ApiResult<T>> {
  try {
    const token = getAccessToken()
    const res = await fetch(`${getBaseUrl()}${path}`, {
      ...init,
      headers: {
        'Content-Type': 'application/json',
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
        ...(init?.headers ?? {}),
      },
    })

    const text = await res.text()
    const json = text ? JSON.parse(text) : {}

    if (!res.ok) {
      const errorMsg = json?.error || json?.message || `Request failed (${res.status})`;
      notification.error({
        message: 'Error',
        description: errorMsg,
        duration: 5,
      });
      return { ok: false, error: errorMsg }
    }

    return { ok: true, data: json as T }
  } catch (e: any) {
    const errorMsg = e?.message || 'Network error';
    notification.error({
      message: 'Error',
      description: errorMsg,
      duration: 5,
    });
    return { ok: false, error: errorMsg }
  }
}

export async function login(username: string, password: string): Promise<ApiResult<{ token: string }>> {
  return requestJson('/api/auth/login', {
    method: 'POST',
    body: JSON.stringify({ username, password }),
  })
}

export interface Admin {
  id: number
  username: string
  email: string
  is_active: boolean
  created_at: number
  last_login_at: number
  last_login_ip: string
}

export interface User {
  id: string
  email: string
  status: string
  created_at: number
  last_login_at: number
}

export async function listAdmins(): Promise<ApiResult<Admin[]>> {
  return requestJson('/api/admins')
}

export async function createAdmin(data: any): Promise<ApiResult<any>> {
  return requestJson('/api/admins', {
    method: 'POST',
    body: JSON.stringify(data),
  })
}

export async function updateAdmin(id: number, data: any): Promise<ApiResult<any>> {
  return requestJson(`/api/admins/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
}

export async function listUsers(): Promise<ApiResult<User[]>> {
  return requestJson('/api/users')
}

export async function updateUser(id: string, data: any): Promise<ApiResult<any>> {
  return requestJson(`/api/users/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(data),
  })
}

export async function changePassword(data: any): Promise<ApiResult<any>> {
  return requestJson('/api/profile/password', {
    method: 'PUT',
    body: JSON.stringify(data),
  })
}
